$(document).ready(() => {
    // Back to top
    $('#top').click(function() { 
        $("html, body").animate({ scrollTop: 0 }, "slow"); 
        return false; 
    });
});



// WEBPACK FOOTER //
// ./src/js/backToTop.js